<template>
  <div class="board">Home</div>
</template>

<script>
export default {
  computed: {},
  methods: {}
};
</script>

<style lang="css"></style>
